import React from 'react';
import { CardCalendarItemStyle } from './style';

export default function CardCalendarItem({ symbol, date, description, color }) {
  return (
    <div>
      <CardCalendarItemStyle borderColor={color}>
        <p>
          {symbol} | {date} | {description}
        </p>
      </CardCalendarItemStyle>
    </div>
  );
}
